import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, Spinner, Pill, statusTone } from "@/components/common";
import { STUDY_STATUS } from "@/lib/i18n";

const Stat = ({ label, value, testId }) => (
  <div className="plena-card px-6 py-5" data-testid={testId}>
    <p className="text-xs font-medium text-plena-text2">{label}</p>
    <p className="mt-1 font-heading text-3xl font-bold tracking-tight">{value}</p>
  </div>
);

export default function OverviewPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setData(r.data)); }, []);
  if (!data) return <Spinner />;
  const s = data.stats;
  return (
    <div className="fade-up">
      <PageHeader eyebrow="Genel Bakış" title="Aday değerlendirme çalışmaları" description="Uzman değerlendiricilerden toplanan yapılandırılmış aday puanları ve sıralamaları." />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat label="Aktif değerlendirme" value={s.active_studies} testId="stat-active" />
        <Stat label="Tamamlanan atama" value={`${s.submitted} / ${s.assignments}`} testId="stat-submitted" />
        <Stat label="Kategori puanı" value={s.label_count} testId="stat-labels" />
        <Stat label="Değerlendirici" value={s.evaluators} testId="stat-evaluators" />
      </div>
      <section className="mt-12">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="font-heading text-base font-semibold md:text-lg">Son değerlendirmeler</h2>
          <Link to="/admin/evaluations" className="text-sm font-medium text-plena-text2 hover:text-plena-text" data-testid="overview-all-link">Tümünü gör</Link>
        </div>
        <div className="space-y-3">
          {data.studies.map((st) => (
            <Link key={st.id} to={`/admin/evaluations/${st.id}${st.status === "DRAFT" ? "/setup" : ""}`} data-testid={`overview-study-${st.id}`} className="plena-card plena-card-hover flex items-center justify-between px-6 py-5">
              <div>
                <p className="font-heading font-semibold">{st.title}</p>
                <p className="mt-1 text-sm text-plena-text2">{st.candidate_count} aday · {st.evaluator_count} değerlendirici · {st.submitted_count} / {st.evaluator_count} tamamlandı</p>
              </div>
              <div className="flex items-center gap-3">
                <Pill tone={statusTone(st.status)}>{STUDY_STATUS[st.status]}</Pill>
                <ArrowRight className="h-4 w-4 text-plena-muted" />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
